import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "already-connected-dialog" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Please connect different account.", -1)

import { useDialogStore } from '@/stores/dialogs';
import { useFacebookStore } from '@/stores/facebook';
import { useTiktokStore } from '@/stores/tiktok';
import { ref } from 'vue';
import InfoIcon from '../icons/other/InfoIcon.vue';
import VButton from '../VButton.vue';
import ConnectSocialDialog from './ConnectSocialDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlreadyConnectedDialog',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as { type: string }



const dialogStore = useDialogStore()
const openAnotherAccount = () => {
  dialogStore.close()
  dialogStore.open(ConnectSocialDialog)
}

const facebookStore = useFacebookStore()
const tiktokStore = useTiktokStore()

const pending = ref(false)
const confirm = async () => {
  pending.value = true
  try {
    if (props.type === "facebook") {
      facebookStore.connectFacebook(true)
    }
    if (props.type === "tiktok") {
      tiktokStore.connectTiktok(true)
    }
    // dialogStore.close()
  } catch(e) {
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InfoIcon),
    _createElementVNode("h2", null, [
      (props.type === 'facebook')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("This Facebook account is already connected")
          ], 64))
        : (props.type === 'tiktok')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("This TikTok account is already connected")
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _hoisted_2,
    _createVNode(VButton, {
      big: "",
      onClick: openAnotherAccount
    }, {
      default: _withCtx(() => [
        _createTextVNode("Connect another account")
      ]),
      _: 1
    }),
    _createVNode(VButton, {
      big: "",
      secondary: "",
      disabled: pending.value,
      onClick: confirm
    }, {
      default: _withCtx(() => [
        _createTextVNode("Disconnect")
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})